import React from 'react';
import styled from 'styled-components';
import { Col } from 'reactstrap';
import { posts } from './blog/postsDefinitions';
import { Link } from 'react-router-dom';

// Styled components
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeaderContainer = styled.div`
  /* Your styles for header */
`;

const BlogContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
  /* Further styling */
`;

const BlogPostCard = styled.article`
  background: #fff;
  border-radius: 8px;
  /* Further styling */
`;

const PaginationContainer = styled.nav`
  /* Your styles for pagination */
`;

// Components
const Header = () => {
  return (
    <HeaderContainer>
      {/* Your header content goes here */}
    </HeaderContainer>
  );
};

const BlogPost = ({ topic, title, excerpt, imageUrl, filePath }) => {
  return (
    <BlogPostCard>
      <Link to={`/company/blog/posts/${filePath}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <div style={{ maxWidth: '200px' }}>
          <img height={200} src={imageUrl} alt={topic} />
          <div style={{ padding: '15px' }}>
            <h2 style={{ fontSize: '12px', color: 'rgb(155,150,150)' }}>{topic}</h2>
            <p style={{ fontSize: '12px' }}>{title}</p>
          </div>
        </div>
      </Link>
      {/* You can add more details like author, date, etc */}
    </BlogPostCard>
  );
};

const Pagination = () => {
  return (
    <PaginationContainer>
      {/* Your pagination links go here */}
    </PaginationContainer>
  );
};

const BlogPage = () => {
  return (
    <PageContainer>
      <Header />
      <Col style={{ maxWidth: '1000px' }}>
        <BlogContainer>
          {posts.map((post, index) => (
            <BlogPost key={index} {...post} />
          ))}
        </BlogContainer>
      </Col>
      <Pagination />
    </PageContainer>
  );
};

export default BlogPage;